import { ButtonModule } from "primeng/button";
import { BrowserModule } from "@angular/platform-browser";
import { CUSTOM_ELEMENTS_SCHEMA, NgModule } from "@angular/core";
import { AppRoutingModule } from "./app-routing.module";
import { AppComponent } from "./app.component";
import { DefaultLayoutComponent } from "./containers/default-layout/default-layout.component";
import { SidebarComponent } from "./views/utils/sidebar/sidebar.component";
import { HeaderComponent } from "./views/utils/header/header.component";
import { FooterComponent } from "./views/utils/footer/footer.component";
import { LoginComponent } from "./views/login/login.component";
import { LoginNewComponent } from "./views/login-new/login-new.component";
import { GlobeAnimationComponent } from "./views/login-new/globe-animation/globe-animation.component";
import { CheckRoutePipe } from "./pipes/check-route.pipe";
import { FilterArrayPipe } from "./pipes/filter-array.pipe";
import { DatePipe } from "@angular/common";
import { HTTP_INTERCEPTORS, HttpClientModule } from "@angular/common/http";
import { ErrorInterceptor } from "./helpers/error.interceptor";
import { JwtInterceptor } from "./helpers/jwt.interceptor";
import { ConfirmationService, MessageService } from "primeng/api";
import { RatingModule } from "primeng/rating";
import { ToastModule } from "primeng/toast";
import { ReactiveFormsModule, FormsModule } from "@angular/forms";
import { NgHttpLoaderModule } from "ng-http-loader";
import { P404Component } from "./views/error/p404/p404.component";
import { BrowserAnimationsModule } from "@angular/platform-browser/animations";
import { ModalModule } from "ngx-bootstrap/modal";
import { ZXingScannerModule } from "@zxing/ngx-scanner";
import { SlickCarouselModule } from "ngx-slick-carousel";
import { ChartModule } from "primeng/chart";
import { OverlayPanelModule } from "primeng/overlaypanel";
import { KeyFilterModule } from "primeng/keyfilter";
import { ProductAuthenticationComponent } from "./views/product-authentication/product-authentication.component";
import { FileUploadModule } from "primeng/fileupload";
import { ForgotPasswordComponent } from "./views/forgot-password/forgot-password.component";
import { NgxAudioPlayerModule } from "ngx-audio-player";
import { CaptchaModule } from "primeng/captcha";
import { TncComponent } from "./views/tnc/tnc.component";
import { HIProductAuthenticationComponent } from "./views/hi-product-authentication/hi-product-authentication.component";
import { AutoCompleteModule } from "primeng/autocomplete";
import { MPPKVVCLAuthenticationComponent } from "./views/mppkvvcl-authentication/mppkvvcl-authentication.component";
import { JkProdAuthComponent } from "./views/jk-prod-auth/jk-prod-auth.component";
import { RazzleDazzleComponent } from "./views/razzle-dazzle/razzle-dazzle.component";
import { HilProductAuthenticationComponent } from "./views/hil-product-authentication/hil-product-authentication.component";
import { IssueNoProductAuthenticationComponent } from "./views/issue-no-product-authentication/issue-no-product-authentication.component";
import { TnProductAuthenticationComponent } from "./views/tn-product-authentication/tn-product-authentication.component";
import { DropdownModule } from "primeng/primeng";
import { RedeemLoyaltyComponent } from "./views/redeem-loyalty/redeem-loyalty.component";
import { CPHIPMECComponent } from "./views/cphi-pmec/cphi-pmec.component";
import { ExperimentalAuthenticationComponent } from "./views/experimental-authentication/experimental-authentication.component";
// import { NgxScannerQrcodeModule } from "ngx-scanner-qrcode";
import { ProductAuthWaComponent } from "./views/product-auth-wa/product-auth-wa.component";
import { TableModule } from "primeng/table";
import { PfhpplComponent } from "./views/pfhppl/pfhppl.component";
import { BharatBiriAuthComponent } from "./views/bharat-biri-auth/bharat-biri-auth.component";
import { IgnoreWheelDirective } from "./ignore-wheel.directive";
import { ForgotPasswordTrendComponent } from "./views/forgot-password-trend/forgot-password-trend.component";
import { PrAuthComponent } from "./views/pr-auth/pr-auth.component";
import { ForgetPasswordArmicaComponent } from "./views/forget-password-armica/forget-password-armica.component";
import { AnalyticsComponent } from "./views/analytics/analytics.component";
import { ProductIntelligenceComponent } from "./views/product-intelligence/product-intelligence.component";
import { GeneratedQrReportComponent } from "./views/generated-qr-report/generated-qr-report.component";
import { RecentAlertsReportComponent } from "./views/recent-alerts-report/recent-alerts-report.component";
import { InventoryReportComponent } from "./views/inventory-report/inventory-report.component";
import { ConfigurationComponent } from "./views/configuration/configuration.component";
import { ReportErrorStateModule } from "./shared/components/report-error-state/report-error-state.module";

@NgModule({
  declarations: [
    AppComponent,
    DefaultLayoutComponent,
    SidebarComponent,
    HeaderComponent,
    FooterComponent,
    LoginComponent,
    LoginNewComponent,
    GlobeAnimationComponent,
    CheckRoutePipe,
    FilterArrayPipe,
    P404Component,
    ProductAuthenticationComponent,
    ForgotPasswordComponent,
    TncComponent,
    HIProductAuthenticationComponent,
    MPPKVVCLAuthenticationComponent,
    JkProdAuthComponent,
    RazzleDazzleComponent,
    HilProductAuthenticationComponent,
    IssueNoProductAuthenticationComponent,
    TnProductAuthenticationComponent,
    RedeemLoyaltyComponent,
    CPHIPMECComponent,
    ExperimentalAuthenticationComponent,
    ProductAuthWaComponent,
    PfhpplComponent,
    BharatBiriAuthComponent,
    IgnoreWheelDirective,
    ForgotPasswordTrendComponent,
    PrAuthComponent,
    ForgetPasswordArmicaComponent,
    AnalyticsComponent,
    ProductIntelligenceComponent,
    GeneratedQrReportComponent,
    RecentAlertsReportComponent,
    InventoryReportComponent,
    ConfigurationComponent,
  ],
  imports: [
    BrowserModule,
    BrowserAnimationsModule,
    ReportErrorStateModule,
    ReactiveFormsModule,
    FormsModule,
    AppRoutingModule,
    ToastModule,
    HttpClientModule,
    ZXingScannerModule,
    SlickCarouselModule,
    RatingModule,
    ChartModule,
    KeyFilterModule,
    OverlayPanelModule,
    ButtonModule,
    ModalModule.forRoot(),
    FileUploadModule,
    NgHttpLoaderModule.forRoot(), // <============ Don't forget to call 'forRoot()'!
    NgxAudioPlayerModule,
    CaptchaModule,
    AutoCompleteModule,
    DropdownModule,
    //NgxScannerQrcodeModule,
    TableModule,
  ],
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
  providers: [
    ConfirmationService,
    MessageService,
    DatePipe,
    { provide: HTTP_INTERCEPTORS, useClass: JwtInterceptor, multi: true },
    { provide: HTTP_INTERCEPTORS, useClass: ErrorInterceptor, multi: true },
  ],

  bootstrap: [AppComponent],
})
export class AppModule {}
